<template>
  <el-dialog width="600px" title="批量修改供应商对账状态" v-model="isvisible">
    <el-form
      ref="supplierFormRef"
      :model="supplierForm"
      :rules="rules"
      label-width="130px"
    >
      <el-form-item label="供应商对账状态" prop="supstatus">
        <el-select
          v-model="supplierForm.supstatus"
          placeholder="选择供应商对账状态"
          style="width: 100%"
        >
          <el-option label="已对账" :value="1" />
          <el-option label="未对账" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="供应商付款状态" prop="suppaystatus">
        <el-select v-model="supplierForm.suppaystatus" placeholder="供应商付款状态" style="width: 100%">
          <el-option label="已付款" :value="1" />
          <el-option label="未付款" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="供应商结算状态" prop="supsetstatus">
        <el-select
          v-model="supplierForm.supsetstatus"
          placeholder="选择供应商结算状态"
          style="width: 100%"
        >
          <el-option label="已结算" :value="1" />
          <el-option label="未结算" :value="2" />
          <el-option label="已抵扣" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="应付金额" prop="suppayamount">
        <el-input
          v-model.trim="supplierForm.suppayamount"
          placeholder="请输入应付金额"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doFinanceSupplier" :loading="loading" >{{
          loading ? "提交中 ..." : "确认"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
    <script setup>
import { ref, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { batchSaveOrderSupplierStatus } from "@/api/order/verify";

let timer;

const emit = defineEmits(["click"]); // 声明父触发事件

const loading = ref(false);

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const supplierFormRef = ref();
const supplierForm = ref({
  orderid: "",
  supcompensation:"",
  supstatus: "",
  suppaystatus: "",
  suppayamount: "",
  supsetstatus: "",
});

const supplierMethod = (obj) => {
  supplierForm.value = {
    orderid: obj.orderid,
    supcompensation: obj.supcompensation,
  };
};

defineExpose({ changeVisible, supplierMethod });

const doFinanceSupplier = () => {
  supplierFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    let orders = [];
    let orderids = supplierForm.value.orderid;
    let supcompensations = supplierForm.value.supcompensation
    for (let i = 0; i < orderids.length; i++) {
      orders.push({
        orderid: orderids[i],
        supcompensation: supcompensations[i],
        supstatus: supplierForm.value.supstatus,
        suppaystatus: supplierForm.value.suppaystatus,
        suppayamount: supplierForm.value.suppayamount,
        supsetstatus: supplierForm.value.supsetstatus,
      });
    }
    // console.log("orders---", orders);
    // console.log("supplierForm.value---", supplierForm.value);

    batchSaveOrderSupplierStatus(orders).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          closeDialog();
          emit('click')
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

const closeDialog = () => {
  isvisible.value = false;
  supplierFormRef.value.resetFields();
  clearTimeout(timer);
};

const validateDecimal = (rule, value, callback) => {
  if (value===''|| typeof(value)=='undefined') {
    callback();
  }
  const reg = /^(\d+\.?)?\d{0,2}$/;
  if (!String(value).match(reg)) {
    callback(new Error("只能填写整数、小数须保留两位小数"));
  } else {
    callback();
  }
};
//表单验证规则
const rules = ref({
  // supstatus: [
  //   {
  //     required: true,
  //     message: "请选择供应商对账状态",
  //     trigger: "change",
  //   },
  // ],
  suppayamount: [
    {
      // required: true,
      message: "请输入应付金额",
      trigger: "blur",
    },
    {
      // required: true,
      validator: validateDecimal,
      trigger: "blur",
    },
  ],
  // supsetstatus: [
  //   {
  //     required: true,
  //     message: "请选择供应商结算状态",
  //     trigger: "change",
  //   },
  // ],
});
</script>
    <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 15px;
}
</style>